import { GridCellParams } from '@mui/x-data-grid'
import Stack from '@mui/material/Stack'

import { CurrencyText } from '../../../common'
import { CategoryGuids } from '../../../core/constants'

export const AmountCell = (params: GridCellParams) => {
  const category = params.row.category_guid
  const parentCategory = params.row.top_level_category_guid
  const isIncome = category === CategoryGuids.INCOME || parentCategory === CategoryGuids.INCOME
  const isTotalRow = params.id === 'total'
  const isTotalColumn = params.field === 'total'
  const amount = isTotalColumn ? params.row[params.field] : params.row.monthlyAmounts[params.field]

  return (
    <Stack alignItems="flex-end" direction="row" tabIndex={params.tabIndex}>
      <CurrencyText
        amount={isIncome ? Math.abs(amount) : amount}
        isIncome={isIncome}
        sx={{ fontWeight: isIncome || isTotalColumn || isTotalRow ? 600 : 500 }}
        symbol={isIncome ? '+' : undefined}
        variant={isTotalRow ? 'body1' : 'body2'}
      />
    </Stack>
  )
}
